import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { selector: to.hash }
    }
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const { action, order_number, step } = to.query
  if (action && action === "editCurtain") {
    const editRoute = { name: 'edit-curtain', params: { articleOrderId: order_number } }
    if (step) {
      editRoute['query'] = { step: step }
    }
    next(editRoute)
  } else {
    next()
  }
})
export default router
